import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header/Header';
import Navigation from './components/Navigation/Navigation';
import Home from './pages/Home/Home';
import SmartCon from './pages/SmartCon/SmartCon';
import Team from './pages/Team/Team';

import './App.scss'

import "@fontsource/golos-ui"; // по умолчанию 400

import "@fontsource/golos-ui/400.css";
import Feedback from './components/Feedback/Feedback';
import Career from './pages/Career/Career';



function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/career" element={<Career />} />
          <Route path="/smartcon" element={<SmartCon />} />
          <Route path="/team" element={<Team />} />
        </Routes>
        <Feedback />
        <Navigation />
      </div>
    </Router>
  );
}

export default App;
